// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "daiane-cavallcante.firebaseapp.com",
  "projectId": "daiane-cavallcante",
  "storageBucket": "daiane-cavallcante.firebasestorage.app",
  "messagingSenderId": "30590090655",
  "appId": "1:30590090655:web:ca95ed72c53c6d48e311aa",
  "measurementId": "G-HY60PWHJTF",
  "apiKey": "AIzaSyCDP5JNEEgJjkWMlGJdlzOK2OTbzUsxtBI"
};
